import React from 'react';

import './FieldLoading.scss';

export const FieldLoading = () => 
    (<span className="field-loading"> (loading)</span>)